import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Button,
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "ui";
import { z } from "zod";

import { trpcClient } from "src/trpc";

const inviteCodeFormSchema = z.object({
  code: z.string(),
});

type InviteCodeFormSchema = z.infer<typeof inviteCodeFormSchema>;

interface InviteCodeFormProps {
  onCancelClick: () => void;
}

export function InviteCodeForm(props: InviteCodeFormProps) {
  const { t } = useTranslation();

  const form = useForm<InviteCodeFormSchema>({
    resolver: zodResolver(inviteCodeFormSchema),
    defaultValues: {
      code: "",
    },
  });

  async function submitInviteCode(data: InviteCodeFormSchema) {
    await trpcClient.useInvitationCode.mutate({ inviteCode: data.code });
    window.location.reload();
  }

  return (
    <Form {...form}>
      <form
        className="space-y-4 md:space-y-6"
        action="#"
        onSubmit={form.handleSubmit(submitInviteCode)}
      >
        <FormField
          control={form.control}
          name="code"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="inline-flex items-center space-x-1">
                <div>{t("promoCodeForm.fields.promoCode.label")}</div>
                <FormDescription className="text-red-500">*</FormDescription>
              </FormLabel>
              <FormControl>
                <Input
                  {...field}
                  autoFocus
                  placeholder={t("promoCodeForm.fields.promoCode.placeholder")}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex justify-between">
          <Button type="button" variant="outline" onClick={props.onCancelClick}>
            {t("promoCodeForm.cancel")}
          </Button>
          <Button type="submit">{t("promoCodeForm.submit")}</Button>
        </div>
      </form>
    </Form>
  );
}
